/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface SwitchProps extends React.SVGAttributes<SVGElement> {
size?: string | number;
}
const Switch: React.FC<SwitchProps> = ({size, ...props}) => (
  <svg viewBox="0 0 20 20" fill="currentColor" width={ size || "20" } height={ size || "20" } {...props}>
    <path d="M5.44542 4.42902C5.73759 4.13541 5.73643 3.66054 5.44282 3.36836C5.1492 3.07619 4.67433 3.07736 4.38216 3.37097L2.17374 5.59026C1.88157 5.88387 1.88273 6.35874 2.17634 6.65091L4.39591 8.85961C4.68952 9.15179 5.16439 9.15062 5.45657 8.85701C5.74874 8.5634 5.74758 8.08853 5.45396 7.79635L4.50297 6.85001H17.1999C17.6141 6.85001 17.9499 6.51422 17.9499 6.10001C17.9499 5.6858 17.6141 5.35001 17.1999 5.35001H4.52894L5.44542 4.42902ZM15.3708 14.5833L14.4543 15.5043C14.1621 15.7979 14.1633 16.2728 14.4569 16.565C14.7505 16.8572 15.2254 16.856 15.5176 16.5624L17.726 14.3431C18.0182 14.0495 18.017 13.5746 17.7234 13.2824L15.5038 11.0737C15.2102 10.7816 14.7353 10.7827 14.4432 11.0763C14.151 11.37 14.1522 11.8448 14.4458 12.137L15.3968 13.0833L2.69995 13.0833C2.28574 13.0833 1.94995 13.4191 1.94995 13.8333C1.94995 14.2476 2.28574 14.5833 2.69995 14.5833L15.3708 14.5833Z"
      fill="currentColor" fillRule="evenodd" clipRule="evenodd" />
  </svg>
);
Switch.displayName = 'Switch';
export default Switch;
/* tslint:enable */
/* eslint-enable */
